export default __webpack_public_path__ + "static/media/review_duotone.96d664c7.svg";